import React, { useState } from 'react';
import Dropdown from 'olive-react-myoneui/lib/Dropdown';
import { globeBoldIcon } from "../constants/icons";
import Button from "olive-react-myoneui/lib/Button";
import { availableLanguages, commonModuleName, langShortLabels } from "../constants/config";
import { setLangInCache } from "../utils/helpers";
import { useTranslation } from "react-i18next";
import { tickIcon } from '../constants/icons';
import { getLangFromCache } from '../utils/helpers';

const langFromCache = getLangFromCache() ?? 'en';

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Button
    role="button"
    tabIndex={0}
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    variant="leading-icon"
    className="btn-round leading-icon btn-sm ps-0"
  >
    {children}
  </Button>
));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('');
    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <ul className="list-unstyled mb-0">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value),
          )}
        </ul>
      </div>
    );
  },
);

function DropdownFlagsPlain({className}) {
  const { t, i18n } = useTranslation(commonModuleName);
  const onLangChange = (lang) => {
    setLanguageSelected(lang);
    i18n.changeLanguage(lang);
    setLangInCache(lang);
    document.getElementById("langHTML").innerHTML = langShortLabels[lang];
  };

  const [set_selection_lang, setLanguageSelected] = useState(langFromCache); 

  return (
  <Dropdown data-bs-offset="7,7" className={`${className || ''} dropdown-select lang-dropdown-wrapper lang-dropdown-plain-wrapper`}>
    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
      <div className="d-flex align-items-center gap-2 flagicon-label">
        <div className="flagicon">
          {globeBoldIcon}
        </div>
        <div className="country-label" id="langHTML">
          {localStorage.curr_lang ? langShortLabels[localStorage.curr_lang] : "Eng"}
        </div>
      </div>
      <div className="caret-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6.119"
          height="11.658"
          viewBox="0 0 6.119 11.658"
        >
          <path
            id="Path_21616"
            data-name="Path 21616"
            d="M0,0,4.42,3.71,8.84,0"
            transform="translate(1.409 10.249) rotate(-90)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      </div>
    </Dropdown.Toggle>
    <Dropdown.Menu as={CustomMenu}>
      {availableLanguages.map((lang, i) => { 
        return (
          <Dropdown.Item
            as="span"
            className="d-flex align-items-center"
            eventKey={i}
            key={"lang_" + i}
            onClick={() => {onLangChange(lang.value)} }
          >
            <span className="px-2">{lang.label}</span>
            {set_selection_lang == lang.value ? <span className="tick-icon">{tickIcon}</span> : ''}
            
          </Dropdown.Item>
        )
      })}
    </Dropdown.Menu>
  </Dropdown>
  )
};

export default DropdownFlagsPlain;